<script lang="typescript">
  import MiscSettings from './misc/MiscSettings.svelte';
  import Panel from '../common/Panel.svelte';
  import Cancel from './cancel/Cancel.svelte';
  import type { Settings } from './types';
  import { create } from './admin';
  import { useMachine } from '../common/myrobot';
  export let settings:Settings;
  const machine = create(settings);
  const { state, context, send } = useMachine(machine);
  const save = () => send('save');
  $:values = $context.settings;
  $:saving = $state == 'saving';
  $:disabled = saving;
  $:error = $context.error;
</script>

<!--
<pre>
{JSON.stringify($state, null, 2)}
</pre>

<pre>
{JSON.stringify($context, null, 2)}
</pre>
-->

<div>
  <form on:submit|preventDefault={save}>
    <p class="form-row">
    <label for="feedback_form_shortcode">Palautelomakkeen shortcode</label>
    <input bind:value={values.feedback_form_shortcode} name="feedback_form_shortcode" id="feedback_form_shortcode" type="text"/>
    </p>
    <p class="form-row">
    <label for="feedback_page">Palautesivun osoite</label>
    <input bind:value={values.feedback_page} name="feedback_page" id="feedback_page" type="text"/>
    </p>
    <p class="form-row">
    <label for="join_page">Liittymis sivun osoite</label>
    <input bind:value={values.join_page} name="join_page" id="join_page" type="text"/>
    </p>
    <p class="form-row">
    <label for="participant_video_page">Asiakkaan video sivu</label>
    <input bind:value={values.participant_video_page} name="participant_video_page" id="participant_video_page" type="text"/>
    </p>
    <p class="form-row">
    <label for="participant_etiquette">Asiakkaan tapaamisetiketti</label>
    <input bind:value={values.etiquette_participant} name="participant_etiquette" id="participant_etiquette" type="text"/>
    </p>
    <p class="form-row">
    <label for="supervisor_etiquette">Ohjaajan tapaamisetiketti</label>
    <input bind:value={values.etiquette_supervisor} name="supervisor_etiquette" id="supervisor_etiquette" type="text"/>
    </p>
    <p class="form-row">
    <label for="product_purchase_deadline">Takaraja tuotteen ostolle tunneissa</label>
    <input bind:value={values.product_purchase_deadline} name="product_purchase_deadline" id="product_purchase_deadline" type="number"/>
    </p>
    <p class="form-row">
    <label for="sender_email">Ajanvaraustietojen lähettäjän sähköposti</label>
    <input bind:value={values.sender_email} name="sender_email" id="sender_email" type="text"/>
    </p>
    <p class="form-row">
    <label for="submit">&nbsp;</label>
    <input name="submit" id="submit" type="submit" value="Tallenna" {disabled} />
    </p>
    {#if saving}
      <p>
      <i class="fas fa-spinner fa-spin fa-lg"></i> Tallennetaan...
      </p>
    {/if}
    {#if error}
      <Panel type="error">
        <p>Virhe asetusten tallennuksessa.</p>
        <p>{error}</p>
      </Panel>
    {/if}
  </form>

  <Cancel/>

</div>

<MiscSettings>
</MiscSettings>

<style>
  label {
    display: block;
  }
  input[type=text] {
    width: 600px;
  }
</style>

